import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BeneficioCompletoComponent } from './beneficio-completo.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    BeneficioCompletoComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule
  ],
  exports: [
    BeneficioCompletoComponent
  ]
})

export class BeneficioCompletoModule { }
